<template>
  <div>
    <router-view></router-view>

    <wh7footer></wh7footer>
  </div>
</template>

<script>
import wh7footer from "./components/wh7/wh7footer.vue";
export default {
  components: {
    wh7footer,
  },
  created(){
    console.log(this.$route)
    if(this.$route.name=='proc_redirect'){
      this.$router.push('/proc/productcenterjgyj/xwyb')
    }
  },
  watch: {
    $route: function () {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>

<style>
</style>